export default __webpack_public_path__ + "static/media/What we do - Icon.143c8017.svg";